import ReactStrapTable from "components/reactStrapTable";
import { Formik } from "formik";
import React, { use, useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import { cellRendererCheck, dateFormate } from "utils/columns";
import Calendar from "assets/icon/calendar-icon.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp} from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import FormikInputField from "components/common/Fields/FormikInputField";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import ReactInputMask from "react-input-mask";
import "react-datepicker/dist/react-datepicker.css";
import useContextService from "hooks/useContextService";
import { cloneDeep } from "lodash";
import DatePicker from "react-datepicker";
import moment from "moment";
import Tooltip from "react-tooltip-lite";
import Question from 'assets/icon/icons8-question-mark.svg'
import PayorCodeList from "components/PayorCodeList";
import { ModuleAccess } from "utils/moduleaccess";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import plus from "assets/icon/plus-icon.svg";
import Drawer from "components/Drawer";
import AddPayor from "./AddPayor";
import ErrorBoundary from "components/ErrorBoundary";
import ReactSelect from 'react-select';
import { Option, LimitedChipsContainer } from 'components/Options';
import reseticon from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";



let addpayorData = {};
    let ceIDs = [];

let rowForEdit = {};
let updatedFields = {};
let hasDatePopupOpen = false;
let PayorBlockOptioons = [
  {
    "id": "Y",
    "label": "Y"
  },
  {
    "id": "N",
    "label": "N"
  }
]
let ceFlag = false;

let initialStates = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
}
let coveredEntityError = "Covered Entity is a required field";
let coveredEntitiesData = [];
const PayorTab = (props) => {
  const {
    states: { configPayorType },
    setStates,
    resetStates
  } = useContextService();
  const { search,searchTerms } = configPayorType;
  const { orgId, key } = props;
  const API = useAxios()
  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [payorDisc, setPayorDisc] = useState('');
  const [payorcode, setPayorCode] = useState('');
  const [showAddPayor, setShowPayor] = useState(true);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [addpayor, setAddPayor] = useState("");
  const [provider, setProvider] = useState('');
  const [payorname, setAddpayorName] = useState("");
  const [errorMessage, setErrorMessage] = useState('')
  const [effectivedate, setEffectiveDate] = useState("");
  const [addpayorerr, setAddPayorerr] = useState("");
  const [addpayornameerr, setAddPayornameerr] = useState("");
  const [dateerror, setDateError] = useState("");
  const [payorcodeerror, setPayorCodeError] = useState("");
  const [totalrecords, setTotalReocrds] = useState([])
  const [currentRowData, setCurrentRowData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [active, setActive] = useState('N');
  const [hasInteracted, setHasInteracted] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [ishiddenflag, setIshiddenflag] = useState(false);
  const [savebuttondisable, setSavebuttondisable] = useState(false);
  const [addpayorflag, setAddpayorflag] = useState(false)
  const toggle = () => setModal(!modal);
  const [columnFilters, setColumnFilters] = useState([]);
  const [hasCESelected, setCESelected] = useState(true);
  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });
    const [showWarning, setShowWarning] = useState('');
  
  const [effectiveTempDate, setEffectiveTempDate] = useState(null)

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };
  const fetchPayorCeFlag = async () => {
    try {
      if (orgId != undefined) {
        const { data } = await API.get(`SBTenant/${orgId.tenantID}/Configuration/payorCeFlag`,
          {
            hasDefaultURL: true,
          }
        );
        if (data == true) {
          ceFlag = true
          fetchCoveredEntities();
        }
        else {
          ceFlag = false;
          fetchPayorTable(search);
        }
      }
    } catch (error) {
      ceFlag = false;
    }


  }

  const handleCoverdEntityChange = (selected, setFieldValue, entity) => {
    // let selected = [selectedces == null ? []: selectedces]

    if (selected) {
      window.selectedCoveredEntittyId = selected;
      window.selectedAccumulatorId = [];
      //accumulationData = [];
      // setSelectedNdc('');
      //   configPayorType.searchTerms.accumulationIDs = {};
      setCESelected(true);
      setCEOptionSelected({
        optionCESelected: selected.value
      });
      let val = selected.value;
      configPayorType.coveredEntities = selected;
      // setFieldValue('coveredEntityIDs', selected);
      configPayorType.searchTerms.coveredEntityIDs = selected;
      if (Array.isArray(configPayorType.searchTerms.coveredEntityIDs)) {
        // accumulationIDs = {};
        configPayorType.searchTerms.accumulationIDs = {};
      }
      updateStates(configPayorType);

    }
    else {

      configPayorType.coveredEntities = [];
      configPayorType.searchTerms.coveredEntityIDs = {};
      setCESelected(false);
    }
    updateStates(configPayorType);
  };
  const updateStates = (configPayorType) => {
    setStates("configPayorType", configPayorType);
  };
  const fetchCoveredEntities = async () => {
    coveredEntitiesData = [];
    if (typeof orgId !== "undefined" && orgId !== null) {
      coveredEntitiesData = [];
      configPayorType.searchTerms.coveredEntityIDs = [];
      updateStates(configPayorType);

      let selectedOrgId = orgId.organizationID;

      setLoading(false);
      try {
        const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
          hasDefaultURL: true,
        });
        setLoading(false);
        if (data) {
          for (var x in data) {
            coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
          }
          configPayorType.coveredEntities = data;

          if (coveredEntitiesData.length == 1) {
            var ceData = [];
            ceData.push(coveredEntitiesData[0])
            configPayorType.searchTerms.coveredEntityIDs = ceData;
            window.selectedCoveredEntittyId = ceData;
          }
          if (window.selectedCoveredEntittyId.length > 0) {
            configPayorType.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
          }

          updateStates(sbreports);
          if (configPayorType.searchTerms.coveredEntityIDs) {

            var ceSelected = [];
            ceSelected.optionCESelected = [];
            for (var x in sbreports.searchTerms
              .coveredEntityIDs) {
              ceSelected.optionCESelected.push(
                configPayorType.searchTerms.coveredEntityIDs[x]
              );
            }
            setCEOptionSelected(ceSelected);
            let ceIds = configPayorType.searchTerms.coveredEntityIDs.map(item => item["value"]);
          }

        }
      }
      catch (err) {
        setLoading(false);
      }
    }

  };
  // const handleSubmit = async () => {

  //   setSavebuttondisable(true);
  //   if (payorname?.length == 0) {
  //     setAddPayornameerr("Payor Name is a required field");
  //     setSavebuttondisable(false);
  //   }
  //   if (effectivedate?.length == 0 || effectivedate == null) {
  //     setDateError("Effective Date is a required field");
  //     setSavebuttondisable(false);
  //   }
  //   if (payorcode?.length == 0 || provider.code?.length == 0) {
  //     setPayorCodeError("Payor Code is a required field");
  //     setSavebuttondisable(false);
  //   }

  //   let AddPayerEntityList = [];
  //   let payload = {};
  //   payload.PayorTypeCode = payorcode,
  //     payload.PayorTypeDesc = payorname,
  //     payload.InactiveFlag = "Y";
  //   payload.EffectiveDate = moment(new Date(effectivedate)).format('YYYY-MM-DD');
  //   AddPayerEntityList.push(payload);

  //   if (payorcode.length > 0 && payorname.length > 0 && effectivedate) {
  //     try {
  //       const result = await API.post(`SBTenant/${orgId.tenantID}/Configuration/AddPayer`, { AddPayerEntityList },

  //         {
  //           hasDefaultURL: true,
  //           hideLoader: true,
  //         }
  //       );
  //       if (result) {
  //         if (result.data[0].success == false) {

  //           setErrorMessage("Payor Code already exists");
  //         }
  //         else {
  //           toast.success("Payor Added Successfully");
  //           fetchPayorTable(search);
  //           handelCancel();
  //         }
  //         setLoading(false);
  //       }

  //     } catch (error) {
  //       console.log(error);
  //       setLoading(false);
  //       setSavebuttondisable(false);
  //     }
  //   }
  // };

  const fetchPayorTable = async (filterObj) => {
    if (filterObj != undefined) {
      initialStates.filters = filterObj.filters
      initialStates.order = filterObj.order ? filterObj.order : initialStates.order
      initialStates.orderBy = filterObj.orderBy ? filterObj.orderBy : initialStates.orderBy
      initialStates.currentPage = filterObj.currentPage ? filterObj.currentPage : initialStates.currentPage
    }
  
    filterObj.CEIDS = ceFlag == true ?  ceIDs :  [];
    setLoading(true);
    try {

      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Configuration/payerlist`, filterObj,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setTotalReocrds(data.totalRecords);
        setData(data.items);
        setTableData(data.items);
      }
      else {
        setTotalReocrds(0)
        setData([]);
        setTableData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  // const fetchPayorByCeId = async (filterObj, ceIds) => {
  //   if (filterObj != undefined) {
  //     initialStates.filters = filterObj.filters
  //     initialStates.order = filterObj.order ? filterObj.order : initialStates.order
  //     initialStates.orderBy = filterObj.orderBy ? filterObj.orderBy : initialStates.orderBy
  //     initialStates.currentPage = filterObj.currentPage ? filterObj.currentPage : initialStates.currentPage
  //   }
  //   setLoading(true);
  //   try {
  //     filterObj.CEIDS = ceIds;
  //     const { data } = await API.post(
  //       `SBTenant/${orgId.tenantID}/Configuration/payorlistByCes/`, filterObj,
  //       {
  //         hasDefaultURL: true,
  //       }
  //     );
  //     if (data?.items?.length > 0) {
  //       setTotalReocrds(data.totalRecords);
  //       setData(data.items);
  //       setTableData(data.items);
  //     }
  //     else {
  //       setTotalReocrds(0)
  //       setData([]);
  //       setTableData([]);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };
  useEffect(() => {
    setModal(false);
    resetStates('configPayorType')
    // search.pageSize=10;
    handelCancel();
   setAddpayorflag((false))
  }, [orgId]);

  const handelCancel = () => {
    setAddPayor('');
    setAddpayorName("");
    setEffectiveDate("");
    setAddPayornameerr("");
    setDateError("");
    setErrorMessage("");
    setPayorCode('');
    setProvider('');
    setSavebuttondisable(false);
    setCESelected(true);
    window.selectedCoveredEntittyId = "";
    setCEOptionSelected({ optionCESelected: "-1" });
setTableData([]);
setTotalReocrds(0);
ceIDs = [];
configPayorType.search = cloneDeep(initialStates);
    configPayorType.searchTerms.coveredEntityIDs = {};
    updateStates(configPayorType);
    // setcollapseSider(true)
  };


  useEffect(() => {
    fetchPayorCeFlag();
  }, [orgId, key]);
  const handelAddpayor = () => {
    setAddpayorflag(!addpayorflag);

  };

  // const handelpayorcode = ({ target: { value } }) => {
  //   setAddPayor(value);
  //   if (value.length > 0) {
  //     setAddPayorerr("");
  //   }
  //   if (value.length == 0) {
  //     setAddPayorerr("Enter the Payor Code");
  //   }
  //   addpayorData.addpayor = value;
  // };

  const handleSubmit = async () => {
    ceIDs = [];
    for (var x in searchTerms.coveredEntityIDs) {
      var rw = searchTerms.coveredEntityIDs[x];
      ceIDs.push(rw.value);
    }
    if (validations(ceIDs));
    if (ceIDs > [0]){
      const filterObj = cloneDeep(search);
      fetchPayorTable(filterObj)
    };
  
  };
  const validations = (ceIDs) => {
    if (ceIDs.length == 0) {
    return  setCESelected(false);
    }
  }
  const handelPayorname = ({ target: { value } }) => {
    setAddpayorName(value);
    if (value.length > 0) {
      setAddPayornameerr("");
    }
    if (value.length == 0) {
      setAddPayornameerr("Payor Name is a required field");
    }
    setSavebuttondisable(false);
    addpayorData.payorname = value
  }
  const handleExport = async () => {
    const filterObj = cloneDeep(search);
    // filterObj.ActiveButton = ActiveButton
       filterObj.CEIDS = ceFlag == true ?  ceIDs :  [];
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID;
    payload.gridCode = "payorList";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });

  };

  const cellRenderEdit = (rowData) => {
    if (rowData.isEdit) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            hidden={!ishiddenflag}
            onClick={() => {
              setCurrentRowData(rowData);
              const tempRow = { ...rowForEdit };
              if (!checkValidation(tempRow)) {
                toggle();
              }
            }}

          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=""
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(rowData, false)}
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    }
    //else {
    return (
      <div className="d-flex align-items-center">
        {renderEditLButton1(rowData)}
      </div>
    );
    //  }
  };

  const editRow = (rowData, isEdit = true) => {
    setShowWarning('');
    if (isEdit == false) {
      setIshiddenflag(false);
    }
    let tempData = [...data];
    if (isEdit) {
      let formattedRowData = { ...rowData };
      if (rowData.effectiveDate) {
        const date = dateFormate(rowData.effectiveDate);
        formattedRowData.effectiveDate = date;
      }
      if (rowData.terminationDate) {
        const date = dateFormate(rowData.terminationDate);
        formattedRowData.terminationDate = date;
      }
      setOriginalData(formattedRowData);
      //setOriginalData({ ...rowData });
    }
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.payorTypeID === rowData?.payorTypeID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    // setTouched('');
    // setSelectedStatus('');
    updatedFields = {};
    //  tableDataBackup = tempData;
    setData(tempData);
  };
  // const checkvalidation = (selectedvaluesonly) => {
  //   if (selectedvaluesonly.payorTypeDesc == null || selectedvaluesonly.payorTypeDesc == "") {
  //     toast.error('Payor Name is Required');
  //     return true;
  //   }
  //   else if ((selectedvaluesonly.effectiveDate == undefined || selectedvaluesonly.effectiveDate == null || selectedvaluesonly.effectiveDate == "")) {
  //     toast.error('Effective Date is requied');
  //     return true;
  //   }

  //   else {
  //     return false;
  //   }

  // }
  // const savePanelUpdateRow = async () => {
  //   setIshiddenflag(false);
  //   if (checkvalidation(rowForEdit))
  //     return true;
  //   toggle();
  //   setLoading(true);
  //   const payload = { ...rowForEdit };
  //   payload.effectiveDate = moment(new Date(payload.effectiveDate)).format('YYYY-MM-DD');
  //   payload.terminationDate = payload.terminationDate != null ? moment(new Date(payload.terminationDate)).format('YYYY-MM-DD') : null;
  //    if(ceIDs.length > 0  && ceFlag == true){
  //     payload.CEIDS = ceIDs;
  //   }
  //   else{
  //     payload.CEIDS = [];
  //   }
  //   delete payload.isEdit;
  //   try {
  //     const result = await API.post(
  //       `SBTenant/${orgId.tenantID}/Configuration/EditPayer`,
  //       payload,
  //       {
  //         hasDefaultURL: true,
  //       },
  //     );

  //     if (result) {

  //       if (result.data.error) {
  //         toast.error(result.data.message);
  //       }
  //       else {
  //         toast.success('payor updated successfully');

  //       }
  //       fetchPayorTable(search);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };
  const checkValidation = (values) => {
  if (!values.payorTypeDesc) {
    toast.error('Payor Name is required');
    return true;
  }
  if (!values.effectiveDate) {
    toast.error('Effective Date is required');
    return true;
  }
  return false;
};

const savePanelUpdateRow = async () => {
  setIshiddenflag(false);

  if (checkValidation(rowForEdit)) return;

  toggle();
  setLoading(true);

  const { effectiveDate, terminationDate, isEdit, ...rest } = rowForEdit;

  const payload = {
    ...rest,
    effectiveDate: moment(new Date(effectiveDate)).format('YYYY-MM-DD'),
    terminationDate: terminationDate
      ? moment(new Date(terminationDate)).format('YYYY-MM-DD')
      : null,
    CEIDS: ceFlag && ceIDs.length > 0 ? ceIDs : [],
  };
  if (payload.terminationDate && new Date(payload.terminationDate) < new Date(payload.effectiveDate)) {
    return setShowWarning('Term Date must be Greater Than or Equal to EffectiveDate');
  }
  try {
    const result = await API.post(
      `SBTenant/${orgId.tenantID}/Configuration/EditPayer`,
      payload,
      { hasDefaultURL: true }
    );

    if (result?.data?.error) {
      toast.error(result.data.message);
    } else {
      toast.success('Payor updated successfully');
      fetchPayorTable(search);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
  }
  const renderEditLButton1 = (rowData) => {
    if (hasPermission('ED'))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => {
            setIshiddenflag(false);
            editRow(rowData);
          }}
          title="Edit Payor"
        >
          <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
        </Button>
      );
  };
  const renderCheckBox = (rowData, col) => {
    // if (hasPermission('EPLS'))

    return (
      <Input
        className="text-primary p-0 text-decoration-none"
        type="checkbox"
        checked={rowData.inactiveFlag === "N"}
        disabled
        title="Active"
      >
      </Input>
    );
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const updateRowValue = (value, col) => {
      if (col === 'terminationDate' && value !== "") {
      setShowWarning('');
    }
    const tempRow = { ...rowForEdit };
    if (rowForEdit.effectiveDate) {
      const date = dateFormate(rowForEdit.effectiveDate);
      tempRow.effectiveDate = date;
    }
    if (rowForEdit.terminationDate) {
      const date = dateFormate(rowForEdit.terminationDate);
      tempRow.terminationDate = date;
    }
    if ((originalData.payorTypeDesc == value && originalData.effectiveDate == tempRow.effectiveDate && originalData.payorBlock == tempRow.payorBlock && originalData.terminationDate == tempRow.terminationDate) || (originalData.effectiveDate == value && originalData.payorTypeDesc == tempRow.payorTypeDesc && originalData.payorBlock == tempRow.payorBlock && originalData.terminationDate == tempRow.terminationDate) || (originalData.payorBlock == value && originalData.effectiveDate == tempRow.effectiveDate && originalData.payorTypeDesc == tempRow.payorTypeDesc && originalData.terminationDate == tempRow.terminationDate) || (originalData.terminationDate == value && originalData.payorBlock == tempRow.payorBlock && originalData.effectiveDate == tempRow.effectiveDate && originalData.payorTypeDesc == tempRow.payorTypeDesc)) {
      setIshiddenflag(false);
      tempRow[col] = value;
      rowForEdit = tempRow;
    } else if (tempRow.payorTypeDesc != value || tempRow.effectiveDate != value || tempRow.payorBlock == value || tempRow.terminationDate != value) {
      setIshiddenflag(true);
      tempRow[col] = value;
      rowForEdit = tempRow;
    }
  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          //hasTouched={hasTouched}
           showWarning={showWarning}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          terminationDateProp={true}
          setEffectiveTempDate={setEffectiveTempDate}
          effectiveTempDate={effectiveTempDate}
        />
      );
    }
    else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          listArray={PayorBlockOptioons}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          requiredFields="text"
        />
      );
    }
  };
  const handlePageChange = (filter, haveColFilter) => {
    updatePayorSearch(filter);
    const filterObj = cloneDeep(search);
    if (haveColFilter) {
      configPayorType.search = { ...configPayorType.search, ...filter };
      filterObj.filters = configPayorType.search.filters;
      fetchPayorTable(filterObj);
    } else {
      configPayorType.search = { ...configPayorType.search, ...filter };
      fetchPayorTable(filterObj);
    }
  };

  const updatePayorSearch = (filter) => {
    //configPayorType.search.currentPage = filter.currentPage;
    //configPayorType.search.pageSize = filter.pageSize;
    configPayorType.search.order = filter.order;
    configPayorType.search.orderBy = filter.orderBy;
  }

  const handleSearchColumnFilters = async (colFilters) => {
    const filterObj = cloneDeep(search);
    if (colFilters && colFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...colFilters];
      setColumnFilters(colFilters)
    }
    configPayorType.search.currentPage = 1;
    filterObj.currentPage = 1;
    await fetchPayorTable(filterObj);
  };
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    
    {
      dataField: "payorTypeCode",
      text: "Payor Code",
      sort: true,
      width: 250,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.payorTypeCode),
    },
    {
      dataField: "payorTypeDesc",
      text: "Payor Name",
      sort: true,
      width: 250,
      // height:100,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => formatter(rowData, col, "text"),
    },
    
    {
      dataField: "payorBlock",
      text: "Payor Block",
      sort: false,
      width: 120,
      // height:100,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => formatter(rowData, col, "statusList"),
    },
    // {
    //   dataField: "inactiveFlag",
    //   text: "Active",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   edit: true,
    //   inputType: "text",
    //   hideColFilter: true,
    //   cellRenderer: (rowData, col) => renderCheckBox(rowData, col),

    // },
    {
      dataField: "effectiveDate",
      text: "Effective Date",
      sort: true,
      width: 170,
      height: 200,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (rowData, col) => formatter(rowData, col, "date"),
      edit: true
    },
    {
      dataField: "terminationDate",
      text: "Termination Date",
      sort: true,
      width: 170,
      height: 200,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (rowData, col) => formatter(rowData, col, "date"),
      edit: true
    },
    // {
    //   dataField: "createdByID",
    //   text: "Created By",
    //   sort: false,
    //   width: 180,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.createdByID),
    // },
    // {
    //   dataField: "createdDate",
    //   text: "Created Date",
    //   sort: false,
    //   width: 180,
    //   show: true,
    //   inputType: "date",
    //   hideColFilter: true,
    //   // edit: true,
    //   cellRenderer: (rowData, col) => dateFormate(rowData.createdDate),


    // },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 170,
      show: true,
      inputType: "date",
      hideColFilter: false,
      // edit: true,
      cellRenderer: (rowData, col) => dateFormate(rowData.modifiedDate),


    },
  ];
   let PayorCECols = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
  {
      dataField: "CoveredentityID",
      text: "Covered Entity",
      sort: false,
      width: 250,
      // height:100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      edit: true,
      cellRenderer: (row) => cellRendererCheck(row.coveredEntityName),
    },
     {
      dataField: "opaCode",
      text: "OPAID",
      sort: false,
      width: 250,
      // height:100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      edit: true,
      cellRenderer: (row) => cellRendererCheck(row.opaCode),
    },
    
    {
      dataField: "payorTypeCode",
      text: "Payor Code",
      sort: true,
      width: 250,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.payorTypeCode),
    },
    {
      dataField: "payorTypeDesc",
      text: "Payor Name",
      sort: true,
      width: 250,
      // height:100,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => formatter(rowData, col, "text"),
    },
    
    {
      dataField: "payorBlock",
      text: "Payor Block",
      sort: false,
      width: 120,
      // height:100,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => formatter(rowData, col, "statusList"),
    },
    // {
    //   dataField: "inactiveFlag",
    //   text: "Active",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   edit: true,
    //   inputType: "text",
    //   hideColFilter: true,
    //   cellRenderer: (rowData, col) => renderCheckBox(rowData, col),

    // },
    {
      dataField: "effectiveDate",
      text: "Effective Date",
      sort: true,
      width: 170,
      height: 200,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (rowData, col) => formatter(rowData, col, "date"),
      edit: true
    },
    {
      dataField: "terminationDate",
      text: "Termination Date",
      sort: true,
      width: 170,
      height: 200,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (rowData, col) => formatter(rowData, col, "date"),
      edit: true
    },
    // {
    //   dataField: "createdByID",
    //   text: "Created By",
    //   sort: false,
    //   width: 180,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.createdByID),
    // },
    // {
    //   dataField: "createdDate",
    //   text: "Created Date",
    //   sort: false,
    //   width: 180,
    //   show: true,
    //   inputType: "date",
    //   hideColFilter: true,
    //   // edit: true,
    //   cellRenderer: (rowData, col) => dateFormate(rowData.createdDate),


    // },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 170,
      show: true,
      inputType: "date",
      hideColFilter: false,
      // edit: true,
      cellRenderer: (rowData, col) => dateFormate(rowData.modifiedDate),


    },
  ];
  const handelClick = () => {
    setShowPayor(false);
  };

  const handleFilterCancel = (filterObj) => {
    setColumnFilters([]);
    search.filters = [];
    configPayorType.search.currentPage = 1;
    fetchPayorTable(search)
    // refetch();
  };

  // const handleCheckbox = (e) => {
  //   const { checked } = e.target;
  //   if (checked) {
  //     setActive('N');
  //   }else{
  //     setActive('Y')
  //   }
  // }
  const onSelect = async (payorcode) => {
    if (payorcode) {
      setProvider(payorcode);
      setPayorCode(payorcode.code);
      if (payorcode.code.length > 0) {
        setPayorCodeError("");
      } else {
        setPayorCodeError("Payer Code is a required field");
      }
      setSavebuttondisable(false);
    } else {
      setPayorCode('');
      setProvider('');
      setSavebuttondisable(false);
    }

  };

  const handleStartDate = (effectivedate) => {
    let stDate = dateFormate(effectivedate);
    setEffectiveDate(stDate);
    addpayorData.effectivedate = moment(new Date(effectivedate)).format('MM/DD/YY');
    if (stDate) {
      setDateError("");
    }
    else {
      setDateError("Effective Date is a required field");
    }
    setSavebuttondisable(false);
  };

  const handleStartDateRaw = (e) => {
    var valdt = new Date();
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    //setHasInteracted(true);
    if (!val || isValid == false || val < valdt) {
      addpayorData.effectivedate = null;
      setEffectiveDate(null);
      // if (hasInteracted) {
      //   setDateError("Effective Date is a required field");
      // }
    } else if (isValid && val >= valdt) {
      handleStartDate(e.target.value);
    }

  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      configPayorType.search.filters = colFilterOn.filters
      configPayorType.search.currentPage = filter.currentPage;
      configPayorType.search.pageSize = filter.pageSize;
      // return onPageChange(colFilterOn, true);
    }
    else {
      configPayorType.search.filters = [];
      configPayorType.search.currentPage = filter.currentPage;
      configPayorType.search.pageSize = filter.pageSize;
    }
    // onPageChange(filter);
    setStates('configPayorType', configPayorType);
    if(ceFlag){
      if(ceIDs.length == 0){
        return true;
      }
    }
    fetchPayorTable(configPayorType.search);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      configPayorType.search = { ...configPayorType.search, ...filter };
      configPayorType.search.filters = colFilterOn.filters
      fetchPayorTable(configPayorType.search);
    } else {
      // onPageChange(filter);
      configPayorType.search = { ...configPayorType.search, ...filter };
      configPayorType.search.filters = [];
      setStates('configPayorType', configPayorType);
      fetchPayorTable(configPayorType.search);
    }
  };
  return (
    <div>
      <Container fluid className='width_info'>
        <Card className='border-0 shadow-top' hidden={ceFlag == false}>
          <CardBody>
            <ErrorBoundary >
              <div >
                <h6 className='f-16 text-primary font-weight-700'>Search Payor</h6>
                <div >
                  <Row sm={5} className='d-flex' style={{}}>
                    <Col md={3} lg={3} sm={6} xs={6}  >
                      {' '}
                      <FormGroup className='ce-reports'>
                        <Label for='coveredentity'>Covered Entity</Label>
                        <ReactSelect
                          name='coveredentity'
                          id='coveredentity'
                          options={coveredEntitiesData}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          optionSelected={true}
                          isClearable={true}
                          components={{
                            Option, ValueContainer: LimitedChipsContainer,
                          }}
                          isSearchable="true"
                          onChange={(value, cp) =>
                            handleCoverdEntityChange(value, cp)}
                          value={selectedCEOption.optionCESelected}
                          className='claim_info required'
                          maxMenuHeight={220}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 99,
                            }),
                            option: (provided) => ({
                              ...provided,
                              display: 'flex',
                              alignItems: 'flex-start',
                            })
                          }}
                        />
                        {!hasCESelected ? (
                          <div className="text-danger f-12 position-absolute">
                            {coveredEntityError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>

                  </Row>
                  <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Col md="auto" >
                      <Label>{""}</Label>
                      <Button

                        color="primary"
                        className="search"
                      onClick={handleSubmit}

                      // disabled={!coveredEntityid}
                      // hidden={!hasPermission("ADD")}
                      >
                        <span className="right_5">
                          <img src={searchicon} alt="" />
                        </span>{" "}
                        Search
                      </Button>
                      <Button
                        // hidden={isAddPermission}
                        // disabled={isSubmitting}
                        color="primary"
                        className="reset"
                        onClick={handelCancel}
                      >
                        <span className="right_5">
                          <img src={reseticon} alt="" />
                        </span>{" "}
                        Reset
                      </Button>

                    </Col>
                  </Row>
                </div>
              </div>
            </ErrorBoundary>
          </CardBody>
        </Card>

        <Card className='border-0 shadow-top'>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="f-16 text-primary font-weight-700" style={{ marginBottom: "0" }}>
                Payor Count ({totalrecords ? totalrecords : 0})
              </h5>
              <Button
                // hidden={isAddPermission}
                // disabled={isSubmitting}
                color="primary"
                className="reset addbtn ms-3"
                onClick={handelAddpayor}
                 disabled={!orgId}
                hidden={!(hasPermission('AD'))}
              // hidden={!(hasPermission('AD'))}
              // disabled={!coveredEntityid}
              // hidden={!hasPermission("ADD")}
              >
                <span className="right_5"><img src={plus} alt="" />
                </span> Add
              </Button>
            </div>

            <hr />

            <div>
              <div
                //   className="table-card scroll-table position-relative border-0 rounded pt-2 z-1"
                // fixed-height={tableData.length > 0 ? "fixed-height":"default"}
                className="table-card scroll-table position-relative border-0 rounded pt-0"
                fixed-height={
                  tableData?.length > 0
                    ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
                    : "default"
                }
              >
                <ReactStrapTable
                  id="payor-table"
                  height={750}
                  fixedColumn
                  width={1200}
                  //display
                  //reset={reset}
                  hasPagination
                  data={tableData}
                  columns={ceFlag == true ? PayorCECols : mainCol}
                  flters={search}
                  onExport={handleExport}
                  //filters={filters}
                  totalRecords={totalrecords}
                  pageSize={search.pageSize}
                  currentPage={search.currentPage}
                  handleSort={handlePageChange}
                  onPageSizeChange={onPageSizeChange}
                  onPageChange={onHandlePageChange}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  onFilterCancel={handleFilterCancel}
                  toggleSider={toggleSider}
                  collapseSider={collapseSider}
                // showtoggle={true}
                />
              </div>
            </div>

          </CardBody>
        </Card>

      </Container>


      {/* <div className="py-2 text-center">
        <span
          style={{ fontSize: "27px", cursor: "pointer" }}
          onClick={toggleSider}
        >
          <FontAwesomeIcon icon={collIcon} className="fa-fw" />
        </span>
      </div> */}

      <div>

        <Modal isOpen={modal} toggle={toggle} className="custom-modal" >
          <ModalHeader className="modal-header-primary" toggle={toggle}>
            Payor Type Change
          </ModalHeader>
          <ModalBody className="custom-modal-body" height="">
            {originalData.effectiveDate !== rowForEdit.effectiveDate ? (
              <><p> Confirm that you want to edit the Effective Date for this Payor Code.</p>
                <p>Payor Code : {originalData?.payorTypeCode} </p>
                <p>Current Effective Date: {dateFormate(originalData?.effectiveDate)} </p>
                <p>New Effective Date: {dateFormate(rowForEdit.effectiveDate)}</p>
                <p>
                  NOTE: All Utilizations with a Drug Administration Date on/or after the New Effective Date (Past and Present)
                  will go through an auto-reprocess the same day. Future Effective Dates do not require a reprocess
                </p>


              </>
            ) : originalData?.payorTypeDesc !== rowForEdit.payorTypeDesc ? (
              <>
                <p> Confirm that you want to edit the Payor Name for this Payor Code.</p>
                <p>Payor Code : {originalData?.payorTypeCode} </p>
                <p>Current Payor Name: {originalData?.payorTypeDesc} </p>
                <p>New Payor Name: {rowForEdit.payorTypeDesc} </p>

              </>
            ) : originalData?.payorBlock !== rowForEdit.payorBlock ? (
              <p><strong>Note : </strong>This change will be applied both historically and going forward. Affected records will be reprocessed.</p>

            ) : <p><strong>Note:</strong>This change will be effective going forward, to reprocess charges in the past please submit a ticket to support@thepharmaforce.com</p>}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" className="modal-button" onClick={savePanelUpdateRow}>OK</Button>
            <Button color="primary" className="modal-button" onClick={toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
        <Drawer
          direction="end"
          title="Add Payor"
          isOpen={addpayorflag}
          toggle={handelAddpayor}
          size="lg"
        >
          <AddPayor handelAddpayor={handelAddpayor} search={search} orgId={orgId} fetchPayorTable={fetchPayorTable} addpayorflag={addpayorflag} setAddpayorflag={setAddpayorflag} payortableData={tableData} coveredEntitiesData={coveredEntitiesData} ceFlag={ceFlag} parentceIDs={ceIDs} handlereset={handelCancel}/>

        </Drawer>

      </div>
    </div>
  );
};

export default PayorTab;
